module.exports = __webpack_public_path__ + "static/img/knowledgeicon.50d53d77.png";